import { ErrorConfig } from './error-layout.component';

export const errorDefaultConfig: Record<number, ErrorConfig> = {
  401: {
    status: 401,
    title: 'Unauthorized',
    message: 'Debe autenticarse para acceder a este recurso',
  },

  403: {
    status: 403,
    title: 'Forbidden',
    message: 'No tienes permiso para acceder a este recurso',
  },
  404: {
    status: 404,
    title: 'Not Found',
    message: 'Página no encontrada',
  },
  500: {
    status: 500,
    title: 'Server Error',
    message: 'Algo salió mal. Inténtalo de nuevo más tarde',
  },
};
